import { render, staticRenderFns } from "./AnnualRevenue.vue?vue&type=template&id=01aaa1fc&scoped=true"
import script from "./AnnualRevenue.vue?vue&type=script&lang=js"
export * from "./AnnualRevenue.vue?vue&type=script&lang=js"
import style0 from "./AnnualRevenue.vue?vue&type=style&index=0&id=01aaa1fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aaa1fc",
  null
  
)

export default component.exports